<template>
  <div class="animate__animated animate__fadeIn">
    <div v-if="MethodService.checkHaveFeature('FT1803')">
      <div class="search-block">
        <el-form
          ref="formSearch"
          :model="tableRules.dataSearch.value"
          :rules="tableRules.dataSearch.valid"
          label-position="top"
          @submit.native.prevent
        >
          <b-row>
            <b-col :md="MethodService.checkHaveFeature('FT1804') ? '6' : '8'" class="pl-0">
              <el-form-item label="">
                <el-input
                  prefix-icon="el-icon-search"
                  clearable
                  v-model="tableRules.dataSearch.value.name_code"
                  placeholder="Tìm kiếm hợp đồng điện tử"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                class="button-show-search button-w100"
              >
                Công cụ tìm kiếm
              </el-button>
            </b-col>
            <b-col md="2">
              <el-button
                @click="fn_goToArchived()"
                type="primary"
                class="button-show-search button-w100"
              >
                Hợp đồng lưu trữ
              </el-button>
            </b-col>
            <b-col md="2" class="pr-0" v-if="MethodService.checkHaveFeature('FT1804')">
              <el-button
                @click="fn_goToCreate()"
                type="primary"
                class="button-show-search button-w100"
              >
                Tạo hợp đồng
              </el-button>
            </b-col>
            <b-collapse
              v-bind:visible="tableRules.showFormSearch"
              id="myFormSearch"
            >
              <b-card>
                <b-row>
                  <b-col md="3" class="pl-0">
                    <el-form-item label="">
                      <el-select
                        clearable
                        v-model="tableRules.dataSearch.value.dda_category_id"
                        placeholder="Loại hợp đồng"
                        @change="fn_tableSearch()"
                      >
                        <el-option
                          v-for="item in dataDefault.listCategories"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="">
                      <el-select
                        clearable
                        v-model="tableRules.dataSearch.value.status"
                        placeholder="Trạng thái"
                        @change="fn_tableSearch()"
                      >
                        <el-option
                          v-for="item in DataService.listStatusOfContract"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                      <el-form-item label="" >
                        <date-picker
                          v-model="dataFind.from_date"
                          type="date"
                          format="DD/MM/YYYY"
                          placeholder="Ngày bắt đầu"
                          @change="fn_tableSearch()"
                          :lang="lang"
                        />
                      </el-form-item>
                    </b-col>
                    <b-col md="3" class="pr-0">
                      <el-form-item label="" >
                        <date-picker
                          v-model="dataFind.to_date"
                          type="date"
                          format="DD/MM/YYYY"
                          placeholder="Ngày kết thúc"
                          @change="fn_tableSearch()"
                          :lang="lang"
                        />
                      </el-form-item>
                    </b-col>
                  <b-col
                    md="2"
                    class="d-flex flex-custom"
                    style="display: none !important"
                  >
                    <el-button
                      type="primary"
                      native-type="submit"
                      class="button-w100"
                      @click="fn_tableSearch()"
                    >
                      Tìm kiếm
                    </el-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-collapse>
          </b-row>
        </el-form>
      </div>
      <div class="table-block">
        <div class="status-filter">
          <div
            :class="{
              'block-status total': true,
              active: typeStatus == 'all',
            }"
            @click="
              () => {
                typeStatus = 'all';
                fn_tableSearch();
              }
            "
          >
            <p>Tất cả ({{ count.all }})</p>
          </div>
          <div
            :class="{
              'block-status unread': true,
              active: typeStatus == 'unread',
            }"
            @click="
              () => {
                typeStatus = 'unread';
                fn_tableSearch();
              }
            "
          >
            <p>Chưa đọc ({{ count.unread }})</p>
          </div>
        </div>
        <el-table
          border
          :max-height="heightTable"
          :data="tableRules.data"
          style="width: 100%"
          @sort-change="fn_tableSortChange"
          :default-sort="{
            prop: tableRules.defaultSort[0],
            order: tableRules.defaultSort[1],
          }"
        >
          <el-table-column label="STT" width="50" align="center">
            <template slot-scope="scope">
              {{ tableRules.offset + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="Tên văn bản" prop="name" min-width="150">
            <template slot-scope="scope">
              <!-- <el-tooltip
                class="item-tooltip"
                effect="light"
                :content="scope.row.name"
                placement="top"
              > -->
              <el-link
                :title="scope.row.name"
                :underline="false"
                type="primary"
                :class="{
                  unread: !checkReaded(scope.row),
                  readed: checkReaded(scope.row),
                }"
                @click="fn_handle('view', scope.row.id, scope.row)"
              >
                {{ scope.row.name }}
              </el-link>
              <!-- <p>{{scope.row.name}}</p> -->
              <!-- </el-tooltip> -->
            </template>
          </el-table-column>
          <el-table-column
            label="Số văn bản"
            prop="code"
            min-width="100"
            :sortable="tableRules.allowSorting"
          >
            <template slot-scope="scope">
              <!-- <el-tooltip
                class="item-tooltip"
                effect="light"
                :content="scope.row.code"
                placement="top"
              > -->
              <p :title="scope.row.code">{{ scope.row.code }}</p>
              <!-- </el-tooltip> -->
            </template>
          </el-table-column>
          <el-table-column
            label="Loại văn bản"
            prop="dda_category_id"
            width="170"
            :sortable="tableRules.allowSorting"
          >
            <template slot-scope="scope">
              {{ findTypeNameById(scope.row.dda_category_id) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Trạng thái"
            prop="status"
            width="150"
            :sortable="tableRules.allowSorting"
          >
            <template slot-scope="scope">
              <el-tag
                :class="
                  scope.row.status == 'DRAFF'
                    ? 'draff'
                    : scope.row.status == 'GENERATING'
                    ? 'generating'
                    : scope.row.status == 'FAILED'
                    ? 'failed'
                    : scope.row.status == 'COMPLETED'
                    ? 'completed'
                    : scope.row.status == 'SIGN_WAITING'
                    ? 'sign_waiting'
                    : scope.row.status == 'SIGN_APPROVED'
                    ? 'sign_approved'
                    : scope.row.status == 'SIGN_REJECTED'
                    ? 'sign_rejected'
                    : ''
                "
              >
                {{
                  scope.row.status == "DRAFF"
                    ? "Nháp"
                    : scope.row.status == "GENERATING"
                    ? "Đang kết xuất"
                    : scope.row.status == "FAILED"
                    ? "Kết xuất lỗi"
                    : scope.row.status == "COMPLETED"
                    ? "Chờ trình ký"
                    : scope.row.status == "SIGN_WAITING"
                    ? "Chờ ký"
                    : scope.row.status == "SIGN_APPROVED"
                    ? "Đã ký"
                    : scope.row.status == "SIGN_REJECTED"
                    ? "Từ chối"
                    : ""
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Người tạo" prop="creator_id" min-width="110">
            <template slot-scope="scope">
              {{ findUserNameById(scope.row.creator_id) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Ngày tạo"
            prop="created_at"
            width="110"
            :sortable="tableRules.allowSorting"
          >
            <template slot-scope="scope">
              {{ MethodService.formatDate(scope.row.created_at, "date") }}
            </template>
          </el-table-column>
          <el-table-column label="Thao tác" width="150">
            <template slot-scope="scope">
              <!-- <el-button
                class="button-action view"
                v-b-popover.hover.left="'Chi tiết'"
                v-if="scope.row.status != 'SIGN_APPROVED' && scope.row.status != 'SIGN_REJECTED' && scope.row.status != 'SIGN_WAITING'"
                @click="fn_handle('view', scope.row.id)"
              >
                <i class="icon isax-eye"></i>
              </el-button> -->
              <!-- <el-button
                class="button-action view"
                v-b-popover.hover.left="'Chi tiết'"
                v-if="scope.row.status == 'SIGN_APPROVED' || scope.row.status == 'SIGN_REJECTED' || scope.row.status == 'SIGN_WAITING'"
                @click="fn_handle('view-approve', scope.row.id)"
              >
                <i class="icon isax-eye"></i>
              </el-button> -->
              <el-button
                class="button-action sign-approval"
                v-b-popover.hover.left="'Ký duyệt'"
                :disabled="!checkTurnSign(scope.row.signers)"
                v-if="
                  checkUserHaveSign(scope.row.signers) &&
                  scope.row.status == 'SIGN_WAITING' &&
                  MethodService.checkHaveFeature('FT1807') &&
                  checkTurnSign(scope.row.signers)
                "
                @click="fn_handle('sign-approval', scope.row.id)"
              >
                <i class="icon icon24-VB_ChoKyNhay"></i>
              </el-button>
              <el-button
                class="button-action sign-process"
                v-b-popover.hover.left="'Trình ký văn bản'"
                v-if="
                  scope.row.status == 'COMPLETED' &&
                  MethodService.checkHaveFeature('FT1806')
                "
                @click="fn_handle('sign-process', scope.row.id)"
              >
                <i class="icon icon24-VB_TrinhKy"></i>
              </el-button>
              <el-button
                class="button-action edit"
                v-b-popover.hover.left="'Sửa'"
                v-if="
                  scope.row.status == 'DRAFF' &&
                  MethodService.checkHaveFeature('FT1805')
                "
                @click="fn_handle('edit', scope.row.id)"
              >
                <i class="icon isax-edit-2"></i>
              </el-button>
              <el-button
                class="button-action copy"
                v-b-popover.hover.left="'Copy'"
                v-if="MethodService.checkHaveFeature('FT1804')"
                @click="fn_handle('copy', scope.row.id)"
              >
                <i class="icon icon24-VB_Copy"></i>
              </el-button>
              <el-button
                class="button-action delete"
                v-b-popover.hover.left="'Xóa'"
                @click="fn_handle('delete', scope.row.id)"
                v-if="!checkDisableButton(scope.row)"
              >
                <i class="icon icon24-Delete"></i>
              </el-button>
              <el-button
                class="button-action download"
                v-b-popover.hover.left="'Xuất file'"
                v-if="
                  scope.row.status != 'DRAFF' &&
                  scope.row.status != 'GENERATING' &&
                  scope.row.status != 'FAILED'
                "
                @click="
                  fn_handle(
                    'download',
                    scope.row.signed_pdf_id
                      ? scope.row.signed_pdf_id
                      : scope.row.unsigned_pdf_id
                  )
                "
              >
                <i class="icon icon24-Download"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="tableRules.allowPaging">
          <div class="col-md-4"></div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="tableRules.lengthMenu"
              :page-size="tableRules.limit"
              :current-page="tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import ExtensionService from "../../../../service/ExtensionService";
import MethodService from "../../../../service/MethodService";
import LanguageService from "../../../../service/LanguageService";
import DataService from "../../../../service/DataService";
import DraffDocumentAutoModel from "./DraffDocumentAutoModel";
import DraffDocumentAutoApi from "@/moduleApi/DraffDocumentAutoApi";
import DdaCategoryApi from "@/moduleApi/DdaCategoryApi";
import ProfileApi from "@/moduleApi/ProfileApi";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/vi";
import { Filter } from "mushroomjs";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      LanguageService,
      MethodService,
      DataService,
      showSide: false,
      moduleName: "DocumentDrafting",
      typeStatus: "all",
      documentName: "",
      detailDocument: {},
      value: null,
      loadingSelect: false,
      showTable: false,
      showContentSign: false,
      dragging: false,
      tableRules: MethodService.copyObject(DraffDocumentAutoModel.tableRules),
      // heightTable: window.innerheight - 280,
      heightTable: 400,
      itemUserSign: null,
      dataDefault: {
        listUsers: [],
        listCategories: [],
        listUserSuggests: [],
        listUserSigns: [],
      },
      dataFind: {
        from_date: undefined,
        to_date: undefined,
      },
      count: {
        all: 0,
        unread: 0,
      },
      currentUser: MethodService.getCurrentUser(),
      userProfile: MethodService.getUserProfile(),
      listEmployeeRoles: MethodService.getListEmployeeRoles(),
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 700,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    getCountDocument() {
      let dataFilter;
      let dataFilterUnread;
      let filterUnreaded = Filter.and(
        Filter.or(
          Filter.eq("creator_id", this.currentUser.id),
          Filter.eq("signers.user_id", this.currentUser.id)
        ),
        Filter.ne("readers.employee_id", this.currentUser.id)
      ).build();
      let filterTotal = Filter.or(
        Filter.eq("creator_id", this.currentUser.id),
        Filter.eq("signers.user_id", this.currentUser.id)
      ).build();
      let filterUnreadAdmin = Filter.ne(
        "readers.employee_id",
        this.currentUser.id
      ).build();
      if (
        (this.userProfile && this.userProfile.type == "COMPANY") ||
        this.listEmployeeRoles.includes('CEO')
      ) {
        dataFilterUnread =
          (this.tableRules.filters ? this.tableRules.filters + "&" : "") +
          filterUnreadAdmin;
        dataFilter = this.tableRules.filters;
      } else {
        dataFilterUnread =
          (this.tableRules.filters ? this.tableRules.filters + "&" : "") +
          filterUnreaded;
        dataFilter =
          (this.tableRules.filters ? this.tableRules.filters + "&" : "") +
          filterTotal;
      }
      Promise.all([
        DraffDocumentAutoApi.list({
          limit: 1,
          filters: dataFilterUnread,
        }),
        DraffDocumentAutoApi.list({
          limit: 1,
          filters: dataFilter,
        }),
      ]).then((res) => {
        this.count.unread = res[0].meta.total;
        this.count.all = res[1].meta.total;
      });
    },
    fn_goToCreate() {
      this.$router
        .push({
          name: `Admin-${this.moduleName}-create`,
        })
        .catch((err) => {});
    },
    fn_goToArchived() {
      this.$router.push({
        name: 'Admin-Document-Archived-list'
      }).catch(() => {})
    },
    checkDisableButton(data) {
      if (
        this.userProfile.type == "COMPANY" &&
        data.status != "SIGN_APPROVED"
      ) {
        return false;
      } else if (
        data.status == "SIGN_APPROVED" ||
        data.status == "SIGN_WAITING" ||
        data.status == "SIGN_REJECTED" ||
        !MethodService.checkHaveFeature("FT1802") ||
        data.creator_id != this.currentUser.id
      ) {
        return true;
      } else {
        return false;
      }
    },
    checkTurnSign(signers) {
      let check = false;
      signers.forEach((item) => {
        if (item.user_id == this.currentUser.id && item.status == "WAITING") {
          check = true;
        }
      });
      return check;
    },
    async initDataDefault() {
      const categoriesApi = await DdaCategoryApi.list({
        limit: 10000,
      });
      this.dataDefault.listCategories = categoriesApi.result;
    },
    async getListDocument() {
      localStorage.removeItem("dataForm");
      let dataFilter = {
        filters: undefined,
        sort: this.tableRules.sort,
        limit: this.tableRules.limit,
        offset: this.tableRules.offset,
      };
      if (
        (this.userProfile && this.userProfile.type == "COMPANY") ||
        this.listEmployeeRoles.includes('CEO')
      ) {
        if (this.typeStatus == "all") {
          dataFilter.filters = this.tableRules.filters
        } else {
          let filterUnreadAdmin = Filter.ne(
            "readers.employee_id",
            this.currentUser.id
          ).build()
          dataFilter.filters = (this.tableRules.filters ? this.tableRules.filters + "&" : "") + filterUnreadAdmin
        }
      } else {
        let filter = "";
        if (this.typeStatus == "all") {
          filter = Filter.or(
            Filter.eq("creator_id", this.currentUser.id),
            Filter.eq("signers.user_id", this.currentUser.id)
          ).build()
        } else {
          filter = Filter.and(
            Filter.or(
              Filter.eq("creator_id", this.currentUser.id),
              Filter.eq("signers.user_id", this.currentUser.id)
            ),
            Filter.ne("readers.employee_id", this.currentUser.id)
          ).build()
        }
        dataFilter.filters = (this.tableRules.filters ? this.tableRules.filters + "&" : "") + filter
      }
      this.replaceRouter();
      const res = await DraffDocumentAutoApi.list(dataFilter);
      this.tableRules.total = res.meta.total;
      this.getCountDocument();
      if (res.result && res.result.length > 0) {
        this.fn_reRender(res.result);
        this.getListUser();
        this.checkHaveStatusGenerating();
      } else {
        this.fn_reRender([]);
      }
    },
    checkHaveStatusGenerating() {
      let result = false;
      this.tableRules.data.forEach((item) => {
        if (item.status == "GENERATING") {
          result = true;
        }
      });
      if (!result) {
        this.clearTimeOut();
      } else {
        window.reloadListDocument = setTimeout(() => {
          this.getListDocument();
        }, 1000 * 5);
      }
    },
    clearTimeOut() {
      if (window.reloadListDocument) {
        clearTimeout(window.reloadListDocument);
      }
    },
    async getListUser() {
      let arrCreatedIds = MethodService.findListItemDifferent(
        this.tableRules.data,
        "creator_id"
      );
      const profileApiRes = await ProfileApi.list({
        filters: "id:in:" + arrCreatedIds.join(","),
      });
      this.dataDefault.listUsers = profileApiRes.result;
    },
    findUserNameById(userId) {
      let user = this.dataDefault.listUsers.find((item) => item.id == userId);
      return user ? user.name.full_name : "";
    },
    findTypeNameById(typeId) {
      let type = this.dataDefault.listCategories.find(
        (item) => item.id == typeId
      );
      return type ? type.name : "";
    },
    fn_reRender(resData) {
      this.tableRules.data = resData;
      console.log("this.tableRules.data", this.tableRules.data);
      if (
        this.tableRules.offset == this.tableRules.total &&
        this.tableRules.page > 1
      ) {
        this.tableRules.page = this.tableRules.page - 1;
        this.tableRules.offset =
          (this.tableRules.page - 1) * this.tableRules.limit;
        this.getListDocument();
      }
    },
    fn_handle(type, id, row) {
      this.clearTimeOut();
      if (type == "sign-approval") {
        this.$router
          .push({
            name: "Admin-" + this.moduleName + "-sign-approve",
            params: {
              id: id,
            },
          })
          .catch((err) => {});
      }
      if (type == "view") {
        let nameTo = "-detail-drafting";
        if (
          row.status == "SIGN_APPROVED" ||
          row.status == "SIGN_REJECTED" ||
          row.status == "SIGN_WAITING"
        ) {
          nameTo = "-detail-approve";
        }
        this.$router
          .push({
            name: "Admin-" + this.moduleName + nameTo,
            params: {
              id: id,
            },
          })
          .catch((err) => {});
      }
      // if (type == 'view-approve') {
      //   this.$router.push({
      //     name: 'Admin-' + this.moduleName + '-detail-approve',
      //     params: {
      //       id: id
      //     }
      //   }).catch(err => {});
      // }
      if (type == "edit") {
        this.$router
          .push({
            name: "Admin-" + this.moduleName + "-update",
            params: {
              id: id,
            },
          })
          .catch((err) => {});
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(async () => {
            try {
              const resDelete = await DraffDocumentAutoApi.delete(id);
              if (resDelete.result > 0) {
                toastr.success("Xóa văn bản thành công");
                this.getListDocument();
              } else {
                toastr.error("Xóa văn bản thất bại");
              }
            } catch (error) {
              toastr.error("Xóa văn bản thất bại");
            }
          })
          .catch(() => {});
      }
      if (type == "copy") {
        this.$confirm("Bạn có chắc chắn muốn sao chép văn bản này không?", {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(async () => {
            this.copyDocument(id);
          })
          .catch(() => {});
      }
      if (type == "download") {
        window.open(ExtensionService.urlDowloadFile + id);
      }
      if (type == "sign-process") {
        this.$router
          .push({
            name: "Admin-" + this.moduleName + "-sign-process",
            params: {
              id: id,
            },
          })
          .catch((err) => {});
      }
    },
    remoteMethod(querySearch) {
      if (querySearch !== "") {
        this.loadingSelect = true;
        setTimeout(() => {
          this.loadingSelect = false;
          this.dataDefault.listUserSuggests =
            this.dataDefault.listUserSuggests.filter((item) => {
              return (
                item.label.toLowerCase().indexOf(querySearch.toLowerCase()) > -1
              );
            });
        }, 200);
      } else {
        this.dataDefault.listUserSuggests = [];
      }
    },
    // copy document
    async copyDocument(id) {
      const res = await DraffDocumentAutoApi.CopyTextEditor(id);
      if (res.result) {
        this.getListDocument();
        toastr.success("Sao chép văn bản thành công");
      } else {
        toastr.error("Sao chép văn bản thất bại");
      }
    },
    replaceRouter() {
      this.$router
        .replace({
          name: "Admin-" + this.moduleName + "-list",
          query: {
            limit: this.tableRules.limit,
            page: this.tableRules.page,
            sort: this.tableRules.sort,
            filters: this.tableRules.filters,
            showFormSearch: this.tableRules.showFormSearch,
            s: this.typeStatus,
          },
        })
        .catch((err) => {});
    },
    fn_tableShowFormSearch() {
      this.tableRules.showFormSearch = !this.tableRules.showFormSearch
      if (this.tableRules.showFormSearch) {
        this.heightTable = window.innerHeight - 390
      } else {
        setTimeout(() => {
          this.heightTable = window.innerHeight - 300
        }, 300)
      }
      let query = Object.assign({}, this.$route.query)
      query.showFormSearch = this.tableRules.showFormSearch
      this.$router
        .replace({
          name: "Admin-" + this.moduleName + "-list",
          query: query,
        })
        .catch((err) => {});
    },
    fn_tableSearch() {
      this.$refs["formSearch"].validate(async (valid) => {
        if (valid) {
          this.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.tableRules.dataSearch)
          )
          let from = this.tableRules.filters.match(/&created_at>=[^&]+/g)
          let to = this.tableRules.filters.match(/&created_at<[^&]+/g)
          if (this.dataFind.from_date) {
            if (from) this.tableRules.filters.replace(from[0], '')
            this.tableRules.filters += `&created_at>=${encodeURIComponent(MethodService.toIsoDate(this.dataFind.from_date))}`
          } else {
            if (from) this.tableRules.filters.replace(from[0], '')
          }
          if (this.dataFind.to_date) {
            this.dataFind.to_date = new Date(
              new Date(this.dataFind.to_date).getFullYear(),
              new Date(this.dataFind.to_date).getMonth(),
              new Date(this.dataFind.to_date).getDate(),
              23,
              59,
              59
            )
            if (to) this.tableRules.filters.replace(to[0], '')
            this.tableRules.filters += `&created_at<${encodeURIComponent(MethodService.toIsoDate(this.dataFind.to_date))}`
          } else {
            if (to) this.tableRules.filters.replace(to[0], '')
          }
          this.tableRules.offset = 0;
          this.getListDocument();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.tableRules.sort = "-" + column.prop;
      } else {
        this.tableRules.sort = "-created_at";
      }
      this.getListDocument();
    },
    fn_tableSizeChange(limit) {
      this.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.tableRules.page = page;
      this.tableRules.offset =
        (this.tableRules.page - 1) * this.tableRules.limit;
      this.getListDocument();
    },
    //Check user có quyền ký hay không
    checkUserHaveSign(listSigner) {
      let check = false;
      if (listSigner) {
        let check1 = listSigner.find((item) => {
          return item.user_id == this.currentUser.id;
        });
        if (check1) {
          check = true;
        }
      }
      // listSigner.forEach(item => {
      //   if (item.user_id == this.currentUser.id) {
      //     check = true;
      //   }
      // });
      return check;
    },
    checkReaded(data) {
      // if (this.currentUser.id == data.creator_id) return true
      if (!data || !data.readers || data.readers.length == 0) return false;
      let checkUserRead = data.readers.find(
        (read) => read.employee_id == this.currentUser.id
      );
      if (checkUserRead) return true;
      return false;
    },
    //Dữ lại filter sau khi F5
    fn_hashUrl() {
      if (this.$route.query.status) {
        if (this.$route.query.status == "DangThucHien") {
          this.tableRules.filters =
            this.tableRules.filters +
            "&status:in:DRAFF,GENERATING,FAILED,COMPLETED";
        }
        if (this.$route.query.status == "ChoKy") {
          this.tableRules.dataSearch.value.status = 'SIGN_WAITING'
          this.tableRules.filters =
            this.tableRules.filters + "&status=SIGN_WAITING";
        }
        if (this.$route.query.status == "DaKy") {
          this.tableRules.dataSearch.value.status = 'SIGN_APPROVED'
          this.tableRules.filters =
            this.tableRules.filters + "&status=SIGN_APPROVED";
        }
      }
      if (this.$route.query.limit) {
        this.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.tableRules.offset =
          (this.tableRules.page - 1) * this.tableRules.limit;
      }
      if (this.$route.query.s) this.typeStatus = this.$route.query.s;

      if (this.$route.query.showFormSearch == "true") {
        this.tableRules.showFormSearch = true;
        this.heightTable = window.innerHeight - 390;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.tableRules.showFormSearch = false;
        this.heightTable = window.innerHeight - 300;
      }
      if (this.$route.query.filters) {
        this.tableRules.filters = this.$route.query.filters;
        // string to object
        this.tableRules.dataSearch.value = MethodService.stringToObject(
          this.tableRules.filters
        );
        let m = this.tableRules.filters.match(/\|?vn_text=([^&\|]*)/g);
        let from = this.tableRules.filters.match(/&created_at>=[^&]+/g)
        let to = this.tableRules.filters.match(/&created_at<[^&]+/g)
        if (m) {
          this.tableRules.dataSearch.value.name_code = decodeURI(m[0].split("=")[1])
          }
        if (from) {
          console.log('from', from)
          this.dataFind.from_date = new Date(decodeURIComponent(from[0].split(">=")[1]))
          console.log('this.dataFind.from_date', this.dataFind.from_date)
        }
        if (to) {
          console.log('to', to)
          this.dataFind.to_date = new Date(decodeURIComponent(to[0].split("<")[1]))
          console.log('this.dataFind.to_date', this.dataFind.to_date)
        }
      }
    },
  },
  created() {
    // let a = [1,2,3,4,5,6,7]
    // let arrAll = []
    // for(let i = 0; i < a.length; i+=2) {
    //   let x = []
    //   x.push(a[i], a[i + 1])
    //   arrAll.push(x)
    // }
    // console.log('arrAll', arrAll)
    MethodService.checkHavePermission("FT1803");
    this.fn_hashUrl();
    this.initDataDefault();
    this.getListDocument();
  },
};
</script>

<style lang="scss" scoped>
.flex-custom {
  align-items: center;
  justify-content: flex-end;
  margin-top: 5px;
}

.button-action {
  &.sign-approval {
    color: var(--orange);
    &:hover {
      color: var(--orange);
    }
  }
  &.view {
    color: var(--orange);
    &:hover {
      color: var(--orange) !important;
    }
  }
  &.edit {
    color: var(--orange);
    &:hover {
      color: var(--orange) !important;
    }
  }
  &.delete {
    color: var(--orange);
    &:hover {
      color: var(--orange) !important;
    }
  }
  &.copy {
    color: var(--orange);
    &:hover {
      color: var(--orange) !important;
    }
  }
  &.download {
    color: var(--orange);
    &:hover {
      color: var(--orange) !important;
    }
  }
  &.sign-process {
    color: var(--orange);
    &:hover {
      color: var(--orange) !important;
    }
  }
  &.is-disabled {
    color: #c0c4cc;
    &:hover {
      color: #c0c4cc !important;
    }
  }
}
.button-show-search {
  width: 215px;
}

::v-deep .search-block .el-button.button-show-search,
::v-deep .search-block .el-button.button-show-search.el-button--primary,
::v-deep .search-block .el-button.button-show-search.el-button--info {
  background-color: var(--orange) !important;
  border-color: var(--orange) !important;
  color: #fff !important;
}

::v-deep .search-block .el-input__inner {
  border-color: #f2bc8e !important;
  &:focus {
    border-color: var(--orange) !important;
  }
}

::v-deep .search-block .el-input__prefix {
  color: var(--orange);
}
.collapse {
  width: 100%;
  .card {
    background: transparent !important;
    .card-body {
      padding-right: 0;
      padding-left: 0;
      .el-form-item {
        margin-bottom: 5px;
      }
    }
  }
}
.search-block {
  padding-left: -15px;
}
::v-deep .table-block {
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  padding: 20px 15px;
  .status-filter {
    display: flex;
    margin-bottom: 10px;
    .block-status {
      height: 44px;
      background: #fff6ef;
      border: 1px solid #f2d1b3;
      border-radius: 8px;
      display: flex;
      align-items: center;
      width: 150px;
      justify-content: center;
      margin-right: 10px;
      &:hover {
        cursor: pointer;
      }
      p {
        color: #bb7a43;
        font-weight: 300;
        font-size: 15px;
        line-height: 24px;
      }
      &.active {
        background: #fff2e5;
        border: 1px solid #e8a266;
        p {
          color: var(--orange);
        }
      }
    }
  }
  .el-table {
    .el-table__header-wrapper th {
      background: #e8914a !important;
      color: #fff !important;
      border-color: rgba(255, 255, 255, 0.35) !important;
    }
    .el-table__body-wrapper {
      .el-table__row {
        &:hover > td {
          background: #fff7f0 !important;
        }
        .el-table__cell {
          .cell {
            p {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .el-link {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 15px;
              line-height: 24px;
              color: var(--orange);
              &.unread {
                .el-link--inner {
                  font-weight: 600;
                }
              }
              &.readed {
                .el-link--inner {
                  font-weight: 300;
                  text-decoration: underline;
                }
              }
            }
          }
          .el-tag {
            &.completed {
              background-color: #01b961;
              border-color: #01b961;
              color: #fff;
            }
            &.draff {
              background-color: #e0e0e0;
              border-color: #e0e0e0;
              color: #575757;
            }
            &.generating {
              background-color: #0a2c6f;
              border-color: #0a2c6f;
              color: #fff;
            }
            &.failed {
              background-color: rgba(0, 0, 0, 0.6);
              border-color: rgba(0, 0, 0, 0.6);
              color: #fff;
            }
            &.sign_waiting {
              background-color: #f2efa9;
              border-color: #f2efa9;
              color: #6b3131;
            }
            &.sign_approved {
              background-color: #00d1ff;
              border-color: #00d1ff;
              color: #fff;
            }
            &.sign_rejected {
              background-color: #ff4a6a;
              border-color: #ff4a6a;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--orange) !important;
  color: #fff !important;
}
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev {
  color: var(--orange);
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar,
::v-deep .el-table__fixed-body-wrapper::-webkit-scrollbar,
::v-deep .mx-datepicker-content::-webkit-scrollbar,
::v-deep .el-select-dropdown__wrap::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-track,
::v-deep .el-table__fixed-body-wrapper::-webkit-scrollbar-track,
::v-deep .mx-datepicker-content::-webkit-scrollbar-track,
::v-deep .el-select-dropdown__wrap::-webkit-scrollbar-track {
  background: #f6e6d8;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb,
::v-deep .el-table__fixed-body-wrapper::-webkit-scrollbar-thumb,
::v-deep .mx-datepicker-content::-webkit-scrollbar-thumb,
::v-deep .el-select-dropdown__wrap::-webkit-scrollbar-thumb {
  background: var(--orange);
  border-radius: 8px;
}
::v-deep .el-table__body-wrapper,
::v-deep .el-table__fixed-body-wrapper,
::v-deep .mx-datepicker-content,
::v-deep .el-select-dropdown__wrap {
  scrollbar-color: var(--orange) #f6e6d8;
  scrollbar-width: thin;
}

::v-deep .mx-datepicker {
  width: 100%;
  .mx-input-wrapper {
    .mx-input {
      height: 42px;
      font-size: 14px;
      color: #606266;
      font-weight: 500;
      line-height: 32px;
      border: 1px solid #c8ced3;
      background: var(--white);
      box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
      border-radius: 10px !important;
      padding: 0 35px 0 15px;
      &::placeholder {
        color: #c8ced3;
        font-family: LexendDeca Regular;
        font-weight: 500;
      }
    }
  }
  svg {
    width: 22px;
    height: 22px;
    vertical-align: middle;
    path {
      fill: #00000080 !important;
    }
  }
}
</style>
<link type="scss" src="./Color.scss" scoped />
